export function getBlankRecord() {
  return {
    id: null,
    providerCode: null,
    vslStatus: null,
    helpStatus: null,
    type: null,
    position: null,
    name: null,
    email: null,
    phone: null,
    phoneDirect: null,
    phoneMobile: null,
    phoneInternational: null,
    created: null,
    firstName: null,
    surname: null,
    title: null,
    role: null,
    sector: null,
    synchroniseWithHits: null,
    promotedHelpPrimary: null,
    promotedVslPrimary: null,
    postalAddresses: []
  };
}
